import { render, staticRenderFns } from "./BlockListContactPersonCustom.vue?vue&type=template&id=1295163c&"
import script from "./BlockListContactPersonCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListContactPersonCustom.vue?vue&type=script&lang=js&"
import style0 from "./BlockListContactPersonCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports